// extracted by mini-css-extract-plugin
export var locationCard = "_hh-0";